import React, { useEffect, useState } from 'react';
import { Col, Row, Tabs, Tab, Card, Form, Button } from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import PageHeader from '../../shared/page-header';
import PassbookService from '../../services/passbook.service';
import { passbookStore } from '../../store/PassbookStore';
import { Pagination } from '../../shared/common/pagination';
import Loader from '../../shared/common/loader';
import WalletTransactions from './components/wallet-Transactions';
import MetalTransactions from './components/metal-transactions';
import { userStore } from '../../store/UserStore';
import { makeQuery } from '../../utils';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import DashboardHttp from '../profile/services/profile.service';
import SupportButton from 'shared/common/supportButton/SupportButton';
import BarAllocationInvoice from './components/metal-invoices';
import Select from 'react-select';
import './styles.css';

interface PropsType {}

interface InvoiceData {
  invoiceNumber: string;
}

const PassBook: React.FC<PropsType> = () => {
  const location = useLocation();
  let ID = new URLSearchParams(location.search).get('customerId');
  let urlMetalCode = new URLSearchParams(location.search).get('metalCode');
  const [setCustomerId, setCustomerDetails] = userStore((state: any) => [
    state.setCustomerId,
    state.setCustomer,
  ]);
  const [metaDataMetal, setMetaDataMetal] = useState<any>({});
  const [metaDataWallet, setMetaDataWallet] = useState<any>({});
  const [currentPageMetal, setCurrentPageMetal] = useState<number>(0);
  const [currentPageWallet, setCurrentPageWallet] = useState<number>(0);
  const [walletLoading, setWalletLoading] = useState<any>(false);
  const [metalLoading, setMetalLoading] = useState<any>(false);
  const [invoiceDataLoading, setInvoiceDataLoding] = useState<any>(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceOptions, setInvoiceOptions] = useState([]);

  const [selectedTab, setSelectedTab] = useState<any>('metalTransactions');

  const [filter, setFilter] = useState<any>({
    qType: '',
    metalCode: '',
    fromDate: '',
    toDate: '',
  });

  const [errors, setErrors] = useState<{ invoiceNumber?: string }>({});

  const [walletFilter, setWalletFilter] = useState<any>({
    transactionType: '',
    debitCredit: '',
    walletInOut: '',
  });

  // eslint-disable-next-line
  const [
    walletTransactions,
    metalTransactions,
    barAllocationInvoice,
    setWalletTransactions,
    setMetalTransactions,
    setBarAllocationInvoice,
  ] = passbookStore((state: any) => [
    state.walletTransactions,
    state.metalTransactions,
    state.barAllocationInvoice,
    state.setWalletTransactions,
    state.setMetalTransactions,
    state.setBarAllocationInvoice,
  ]);

  const [customerId, user, selectedAccount] = userStore((state: any) => [
    state.customerId,
    state.user,
    state.selectedAccount,
  ]);

  useEffect(() => {
    (async () => {
      document.title = 'Passbook - CoinBazaar Digital';
      if (ID) {
        setCustomerId(ID);
        getProfile(ID);
      }
      await getWalletTransactions(currentPageWallet);
    })();
  }, []);

  useEffect(() => {
    if (urlMetalCode) {
      setFilter({ ...filter, metalCode: urlMetalCode });
      getMetalTransactions(currentPageMetal, false, urlMetalCode);
    } else {
      getMetalTransactions(currentPageMetal);
    }
  }, [urlMetalCode, selectedAccount]);

  useEffect(() => {
    setBarAllocationInvoice([]);
    getAllInvoices();
  }, []);

  const getAllInvoices = async () => {
    try {
      const res: any = await PassbookService.getBarInvoices();
      if (res.status === 200 && res.data.data) {
        setInvoiceOptions(res ? res.data.data.invoiceDetail : []);
        // setErrors({});
      }
    } catch (e: any) {}
  };

  const getProfile = async (customerId: any) => {
    try {
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setCustomerDetails(userData.data.data.customer);
      }
    } catch (e: any) {
      console.log(e);
      //setLoading(false);
    }
  };

  /**
   * Get wallet transactions
   * @param page
   * @param isReset
   */
  const getWalletTransactions = async (
    page: number,
    isReset: boolean = false
  ) => {
    try {
      let cloneFilterData = !isReset
        ? { ...walletFilter }
        : {
            transactionType: '',
            debitCredit: '',
            walletInOut: '',
          };

      const query = makeQuery(cloneFilterData);
      setWalletLoading(true);

      const res: any = await PassbookService.getWalletTransactions(
        customerId,
        page,
        user?.userId,
        query
      );
      if (res.status === 200 && res.data.data) {
        setCurrentPageWallet(page);
        setMetaDataWallet({
          current: res.data.meta.page,
          pages: res.data.meta.totalPages,
        });
        setWalletTransactions(res ? res.data.data.result : []);
      }
    } catch (e: any) {
    } finally {
      setWalletLoading(false);
    }
  };

  const getBarAllocationInvoiceData = async (invoiceNumber: any) => {
    try {
      if (
        !invoiceNumber ||
        invoiceNumber === undefined ||
        invoiceNumber === null
      ) {
        setErrors({ invoiceNumber: 'Please select an invoice' });
        return;
      }
      const res: any = await PassbookService.getBarAllocationInvoice(
        invoiceNumber
      );
      if (res.status === 200 && res.data.data) {
        setBarAllocationInvoice(res ? res.data.data.invoiceDetail : []);
        setErrors({});
      }
    } catch (e: any) {
    } finally {
      setInvoiceDataLoding(false);
    }
  };
  /**
   * Get metal transactions
   * @param page
   * @param isReset
   */
  const getMetalTransactions = async (
    page: number,
    isReset: boolean = false,
    urlMetalCode: string = null
  ) => {
    try {
      setMetalLoading(true);
      let cloneFilterData = !isReset
        ? { ...filter }
        : {
            qType: '',
            metalCode: '',
            fromDate: '',
            toDate: '',
          };

      if (cloneFilterData.fromDate !== '' && cloneFilterData.toDate !== '') {
        cloneFilterData.fromDate = moment(cloneFilterData.fromDate).format(
          'MM/DD/yyyy'
        );
        cloneFilterData.toDate = moment(cloneFilterData.toDate).format(
          'MM/DD/yyyy'
        );
      }
      if (urlMetalCode) {
        cloneFilterData.metalCode = urlMetalCode;
      }
      const query = makeQuery(cloneFilterData);
      const res: any = await PassbookService.getMetalTransactions(
        customerId,
        page,
        selectedAccount.accountId,
        user?.userId,
        user?.partner?.id,
        query
      );
      if (res.status === 200 && res.data.data) {
        setCurrentPageMetal(page);
        setMetaDataMetal({
          current: res.data.meta.page,
          pages: res.data.meta.totalPages + 1,
        });
        setMetalTransactions(res ? res.data.data.result : []);
      }
      setMetalLoading(false);
    } catch (err: any) {
      setMetalLoading(false);
      if (err?.data?.errors?.length > 0) {
        return toast.error(err.data.errors[0].title);
      }
    }
  };

  /**
   * Handle filters change event
   * @param e
   */
  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;
    if (name === 'walletInOut') {
      if (value == 'IN') {
        setWalletFilter({
          transactionType: ['WALLET', 'ORDER_BUYBACK', 'ORDER_REFUND'],
          walletInOut: value,
        });
      } else if (value == 'OUT') {
        setWalletFilter({
          transactionType: ['WALLET', 'ORDER_SELL'],
          walletInOut: value,
        });
      } else {
        setWalletFilter({
          transactionType: [],
          walletInOut: '',
        });
      }
      //
      // setWalletFilter({
      //   ...walletFilter,
      //   walletInOut: value
      // })
    } else {
      setFilter({
        ...filter,
        // [name]: name === 'fromDate' || name === 'toDate' ? moment(value).format('DD/MM/yyyy') : value
        [name]: value,
      });
    }
  };

  const handleInvoiceChange = (selectedOption) => {
    setSelectedInvoice(selectedOption);
    setErrors({}); // Reset errors when a new invoice is selected
  };

  /**
   * Set filter data to initial state
   */
  const setFilterInitialState = async () => {
    setFilter({
      qType: '',
      metalCode: '',
      fromDate: '',
      toDate: '',
    });

    setCurrentPageMetal(0);
    await getMetalTransactions(0, true);
  };

  /**
   * Set wallet filter data to initial state
   */
  const setWalletFilterInitialState = async () => {
    setWalletFilter({
      transactionType: '',
      debitCredit: '',
      walletInOut: '',
    });

    setCurrentPageWallet(0);
    await getWalletTransactions(0, true);
  };

  /**
   * Set selected tab key
   * @param tab
   */
  const onChangeTab = (tab) => {
    setSelectedTab(tab);
  };

  const handleReset = () => {
    setBarAllocationInvoice([]);
    setSelectedInvoice(null);
    setErrors({});
  };

  function isValidInvoice(selectedInvoice) {
    if (!selectedInvoice || selectedInvoice == '') {
      return false;
    }

    if (selectedInvoice.length < 5) {
      return false;
    }

    if (!/^[a-zA-Z0-9]+$/.test(selectedInvoice)) {
      return false;
    }

    return true;
  }

  return (
    <Layout>
      <div className='pb'>
        <PageHeader
          mainTitle='Passbook'
          subTitle='All your transaction details'
          isShowSub={true}
          // isShowSub={selectedTab === 'metalTransactions'}
        />
        {walletLoading || metalLoading || invoiceDataLoading ? (
          <Loader />
        ) : (
          <Row>
            <Col md={12}>
              <Tabs
                defaultActiveKey={selectedTab}
                id='uncontrolled-tab-example'
                className='mb-3'
                onSelect={onChangeTab}
              >
                <Tab eventKey='metalTransactions' title='Metal Transactions'>
                  <div>
                    <h6>Past Transactions</h6>
                    <Card>
                      <Card.Body>
                        <Row className='align-items-center'>
                          <Col md={3}>
                            <Form.Group className='mb-3' controlId='orderType'>
                              <Form.Label>Order Type</Form.Label>
                              <Form.Select
                                aria-label='Default select example'
                                name='qType'
                                onChange={(e) => handleChangeFilter(e)}
                                value={filter.qType}
                              >
                                <option value=''>All Transactions</option>
                                <option value='BUYBACK'>Sell</option>
                                <option value='SELL'>Buy</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <Form.Group className='mb-3' controlId='orderMetal'>
                              <Form.Label>Order Metal</Form.Label>
                              <Form.Select
                                aria-label='Default select example'
                                name='metalCode'
                                onChange={(e) => handleChangeFilter(e)}
                                value={filter.metalCode}
                              >
                                <option value=''>All metals</option>
                                <option value='Ag'>Silver (Ag)</option>
                                <option value='Au'>Gold (Au)</option>
                                <option value='Pt'>Platinum (Pt)</option>
                                <option value='Pd'>Palladium (Pd)</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col md={2}>
                            <Form.Group className='mb-3' controlId='orderType'>
                              <Form.Label>Order From Date</Form.Label>
                              <Form.Control
                                type='date'
                                name='fromDate'
                                onChange={(e) => handleChangeFilter(e)}
                                value={filter.fromDate}
                              ></Form.Control>
                            </Form.Group>
                          </Col>

                          <Col md={2}>
                            <Form.Group className='mb-3' controlId='orderType'>
                              <Form.Label>Order To Date</Form.Label>
                              <Form.Control
                                type='date'
                                name='toDate'
                                onChange={(e) => handleChangeFilter(e)}
                                value={filter.toDate}
                                min={filter.fromDate}
                                disabled={filter.fromDate === ''}
                              ></Form.Control>
                            </Form.Group>
                          </Col>

                          <Col md={2} className='p-0 pt-2'>
                            <Button
                              onClick={() => getMetalTransactions(0)}
                              className='mx-2'
                              variant='primary'
                            >
                              Apply
                            </Button>
                            <Button
                              onClick={setFilterInitialState}
                              variant='secondary'
                            >
                              Reset
                            </Button>
                          </Col>
                          {/*<Col md={1} className="pt-2">*/}
                          {/*  <Button onClick={setFilterInitialState} variant="secondary">Reset</Button>*/}
                          {/*</Col>*/}
                        </Row>
                      </Card.Body>
                    </Card>
                    <div className='t-wrap overflow-auto'>
                      <MetalTransactions metalData={metalTransactions} />
                    </div>
                    <Row>
                      <Col md={12}>
                        {/* Pagination Bar */}
                        {!metalLoading && (
                          <Pagination
                            meta={metaDataMetal}
                            handlePageChange={(number: number) =>
                              getMetalTransactions(number)
                            }
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </Tab>
                <Tab eventKey='walletTransactions' title='Wallet Transactions'>
                  <div>
                    <h6>Wallet Transactions</h6>
                    <Card>
                      <Card.Body>
                        <Row className='align-items-center justify-content-center'>
                          <Col md={5}>
                            <Form.Group className='mb-3' controlId='orderType'>
                              <Form.Label>Transaction Type</Form.Label>
                              <Form.Select
                                aria-label='Default select example'
                                name='walletInOut'
                                onChange={(e) => handleChangeFilter(e)}
                                value={walletFilter.walletInOut}
                              >
                                <option value=''>All Transactions</option>
                                <option value='IN'>Wallet Credit</option>
                                <option value='OUT'>Wallet Debit</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>

                          <Col md={2} className='p-0 pt-2'>
                            <Button
                              onClick={() => getWalletTransactions(0)}
                              className='mx-2'
                              variant='primary'
                            >
                              Apply
                            </Button>
                            <Button
                              onClick={setWalletFilterInitialState}
                              variant='secondary'
                            >
                              Reset
                            </Button>
                          </Col>
                          {/*<Col md={1} className="pt-2">*/}
                          {/*  <Button onClick={setWalletFilterInitialState} variant="secondary">Reset</Button>*/}
                          {/*</Col>*/}
                        </Row>
                      </Card.Body>
                    </Card>
                    <div className='t-wrap overflow-auto'>
                      <WalletTransactions walletData={walletTransactions} />
                    </div>
                    <Row>
                      <Col md={12}>
                        {/* Pagination Bar */}
                        {!walletLoading && (
                          <Pagination
                            meta={metaDataWallet}
                            handlePageChange={(number: number) =>
                              getWalletTransactions(number)
                            }
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </Tab>
                <Tab eventKey='invoices' title='Search By Invoice'>
                  <div>
                    <h6>Search By Invoice</h6>
                    <Card>
                      <Card.Body>
                        <Row className='align-items-center justify-content-center'>
                          <Col md={5}>
                            <Form.Group
                              className='mb-3'
                              controlId='invoiceNumber'
                            >
                              <Form.Label>Invoice Number</Form.Label>

                              <Select
                                placeholder='Select Invoice Number'
                                options={invoiceOptions.map((option: any) => ({
                                  value: option?.ebInvoiceRef,
                                  label: option?.ebInvoiceRef,
                                }))}
                                value={selectedInvoice}
                                onChange={handleInvoiceChange}
                              />

                              {errors && errors.invoiceNumber && (
                                <div className='text-danger'>
                                  &#9888; Please select an invoice number
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={2} className='p-0 pt-2'>
                            <Button
                              onClick={() =>
                                getBarAllocationInvoiceData(
                                  selectedInvoice?.value
                                )
                              }
                              className='mx-2'
                              variant='primary'
                            >
                              Search
                            </Button>
                            <Button onClick={handleReset} variant='secondary'>
                              Reset
                            </Button>
                            {errors && errors.invoiceNumber && (
                              <div className='col-12 text-danger text-right mt-4'></div>
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <div className='t-wrap overflow-auto'>
                      <BarAllocationInvoice
                        invoiceData={barAllocationInvoice}
                      />
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        )}
        {/* <SupportButton /> */}
      </div>
    </Layout>
  );
};

export default PassBook;
